// NavBar.jsx
import React, { useEffect, useState } from "react";
import "./NavBar.css";

// If you're using react-router, UNCOMMENT the next two lines and use <NavLink> below.
// import { NavLink, useLocation } from "react-router-dom";

const NavBar = () => {
  const [open, setOpen] = useState(false);

  // If you're using react-router, UNCOMMENT this and the useEffect below.
  // const location = useLocation();

  // useEffect(() => {
  //   setOpen(false); // close menu on route change
  // }, [location.pathname]);

  // If you are NOT using react-router, this keeps active styling working:
  const isActivePath = (path) => {
    if (typeof window === "undefined") return false;
    return window.location.pathname === path;
  };

  return (
    <header className="psoc-nav">
      <div className="psoc-nav__inner">
        <a className="psoc-nav__brand" href="/" aria-label="Production Studio of Colorado home">
          <img className="psoc-nav__logo" src="/logo.png" alt="Production Studio Logo" />
          <span className="psoc-nav__brandText">Production Studio of Colorado</span>
        </a>

        <button
          type="button"
          className="psoc-nav__toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="psoc-nav-menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="psoc-nav__toggleBar" />
          <span className="psoc-nav__toggleBar" />
          <span className="psoc-nav__toggleBar" />
        </button>

        <nav
          id="psoc-nav-menu"
          className={`psoc-nav__menu ${open ? "is-open" : ""}`}
          aria-label="Primary"
        >
          {/* If using react-router, replace <a> with:
              <NavLink to="/" className={({isActive}) => `psoc-nav__link ${isActive ? "is-active" : ""}`} end>Home</NavLink>
          */}
          <a className={`psoc-nav__link ${isActivePath("/") ? "is-active" : ""}`} href="/">
            Home
          </a>
          <a
            className={`psoc-nav__link ${isActivePath("/video-production") ? "is-active" : ""}`}
            href="/video-production"
          >
            Video Production
          </a>
          <a className={`psoc-nav__link ${isActivePath("/real-estate") ? "is-active" : ""}`} href="/real-estate">
            Real Estate
          </a>
          <a className={`psoc-nav__link ${isActivePath("/weddings") ? "is-active" : ""}`} href="/weddings">
            Weddings
          </a>
          {/* <a className={`psoc-nav__link ${isActivePath("/casting") ? "is-active" : ""}`} href="/casting">Casting</a> */}
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
